module.exports = __webpack_public_path__ + "img/shop5-1.24e64933.png";